<mat-toolbar color="basic" class="header-v2" 
  [ngStyle]="{ 'background-color': environmentVariables?.HEADER_BACKGROUND_COLOR }">
  <mat-toolbar-row 
    [ngStyle]="{ 'background-color': environmentVariables?.HEADER_BACKGROUND_COLOR }" 
    class="responsive-bar responsive-bar-mobile-screen relative">
    <div class="container">
      <div fxLayoutAlign="space-between">
        <button class="responsive-toggle" mat-icon-button (click)="toggleSidebar()">
          <mat-icon class="material-icons material-icons material-icons-dark" 
            [ngClass]="{ 
              'material-symbols-outlined': environmentVariables?.ENABLE_HEADER_ICONS_FILL === false,
              'icons-fill-color': environmentVariables?.HEADER_ICONS_FILL_COLOR }">
            menu
          </mat-icon>
        </button>

        <a class="d-flex align-items-center" [routerLink]="['/' + lang + '/']">
          <img class="object-fit-contain" loading="lazy" *ngIf="lang == 'en'" [src]="environmentVariables?.COLORED_LOGO_EN" alt="logo image" [ngStyle]="{ width: environmentVariables?.logoWidthMobile,
			height: environmentVariables?.logoHeightMobile,
			position: 'relative' }"/>
          <img class="object-fit-contain" loading="lazy" *ngIf="lang == 'ar'" [src]="environmentVariables?.COLORED_LOGO_AR" alt="logo image" [ngStyle]="{ width: environmentVariables?.logoWidthMobile,
			height: environmentVariables?.logoHeightMobile,
			position: 'relative' }"/>
        </a>
        
        <div class="search-box-bar-container">
          <div class="search-box-bar position-relative" style="top: 4px;">
            <button class="header-icon mr-0" type="button" mat-mini-fab (click)="toggleSearch()"
              [ngClass]="{
                'white-outline': environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
                'icons-background':
                  environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                  environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
                'defult-background-icons': !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
              }">
              <mat-icon (mouseover)="changeIconFill = false" (mouseleave)="changeIconFill = true"
                class="material-icons notranslate defulat-icons-color" 
                [ngClass]="{
                  'material-symbols-outlined': changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false,
                  'icons-fill-color': environmentVariables?.HEADER_ICONS_FILL_COLOR
                }">
                search
              </mat-icon>
            </button>
          </div>
          <div class="form-open" *ngIf="showSearch">
            <div class="search-form">
              <form autocomplete="off" (submit)="searchInProducts($event)">
                <input 
                  #searchValue 
                  id="inputSearchMobile" 
                  type="text" 
                  placeholder="{{ 'input_text.InputSearch2' | translate }}" 
                  [appFocus]="true" inputmode="search" autocomplete="off" 
                  (keyup)="completeResultsLoaded = false;
                    completResults = null;
                    autoCompleteSearch($event, searchValue.value)" />
                <button type="button" mat-fab class="close-btn" (click)="toggleSearch()">
                  <mat-icon class="material-icons">
                    close
                  </mat-icon>
                </button>
                <button type="button" mat-fab class="close-btn" 
                  (click)="searchInProductsMobile(searchValue)" 
                  [class.right-52]="lang == 'en'" 
                  [class.left-52]="lang == 'ar'">
                  <img loading="lazy" *ngIf="loadingAutoComplete" class="mobile-search-loading"
                    src="./../../../../assets/images/Spinner-loading.svg" alt="mobile search loading" />
                  <mat-icon class="material-icons">
                    search
                  </mat-icon>
                </button>
              </form>
              <div *ngIf="isMenuOpen" 
                class="res_search_div" 
                id="autocomp" 
                [ngClass]="{ 'border-search': completeResultsLoaded && searchValue.value?.length != 0 }">
                <div class="row">
                  <div class="col-md-6" *ngFor="let product of completResults">
                    <div class="div_data" (click)="showProductPage(product)">
                      <div class="div1" *ngIf="product?.image">
                        <img loading="lazy" data-src="{{
                                                        product?.image
                                                    }}" onError="this.src='./assets/images/placeholder200.jpg';"
                          class="lazyload" alt="product imgae" />
                      </div>
                      <div class="div2">
                        <h6>
                          {{
                          lang == "ar"
                          ? product.name_ar
                          : product.name_en
                          }}
                        </h6>
                        <div class="d-flex align-items-start">
                          <div class="my-2" class="d-flex align-items-start">
                            <del style="font-size: 13px !important;" 
                              *ngIf="product?.discount_price && environmentVariables?.GUEST_CAN_VIEW_PRICES" 
                              [ngClass]="{
                                'config-price-after-discount':
                                  product?.discount_price &&
                                  environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                'config-price-color':
                                  environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                'defult-price-color-after-discount':
                                  !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                  product?.discount_price,
                                'price-ar':
                                  lang == 'ar'
                              }">
                              {{ product?.price }}
                              {{ lang == "en"
                                ? environmentVariables?.CURRENCY_CODE_EN
                                : environmentVariables?.CURRENCY_CODE_AR
                              }}
                            </del>
                            <div>
                              <ng-container *ngIf="product?.price && environmentVariables?.GUEST_CAN_VIEW_PRICES ">
                                <span class="defult-price-color payment-with-discount-container d-flex" 
                                  [ngClass]="{ 'config-price-color': environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                              'price-ar':  lang == 'ar' }">
                                  {{ product?.discount_price !== null
                                    ? product?.discount_price
                                    : product?.price
                                  }}
                                  {{ lang == "en"
                                    ? environmentVariables?.CURRENCY_CODE_EN
                                    : environmentVariables?.CURRENCY_CODE_AR
                                  }}
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p *ngIf="
                    completResults &&
                    !completResults?.length &&
                    searchValue.value?.length != 0 &&
                    completeResultsLoaded
                  " 
                  class="empty_p">
                  {{ "auto_complete.no_results" | translate }}
                </p>
                <p (click)="moreProductsClick()" 
                  *ngIf="searchValue.value?.length != 0 &&
                      !completeResultsLoaded" 
                  class="auto-complete-text">
                  {{ "auto_complete.view_all_search_about" | translate }}
                  <b> "{{ searchValue.value }}"</b>
                </p>
                <div class="btn_div" *ngIf="completResults?.length > 9">
                  <button mat-raised-button (click)="moreProductsClick()">
                    {{ "home_Page.viewAll" | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar-row>

  <mat-toolbar-row color="basic" class="header-v2-top" 
    [ngStyle]="{ 'background-color': environmentVariables?.HEADER_BACKGROUND_COLOR }">
    <div class="container">
      <div fxLayout="row wrap" class="centerOnMobileScreen">
        <div class="logo-site">
          <a [routerLink]="['/' + lang + '/']">
            <img loading="lazy"
              [src]="lang == 'en' ? environmentVariables?.COLORED_LOGO_EN : 
                environmentVariables?.COLORED_LOGO_AR" 
              alt="logo image"
              [width]="environmentVariables?.logoWidth" 
              [height]="environmentVariables?.logoHeight"
              class="object-fit-contain object-position-0"
              [ngStyle]="{
                'width': environmentVariables?.logoWidth,
                'height': environmentVariables?.logoHeight
              }" />
          </a>
        </div>
        <div class="search-bar align-center" fxFlex.sm.hide fxHide.xs="true" fxHide.sm="true" 
          *ngIf="!environmentVariables?.ENABLE_SEARCH_AS_ICON || expandedSearchBar">
          <div class="search-v2">
            <form autocomplete="off" action="">
              <input id="searchBar" 
                [ngClass]="{'opened_search_input': environmentVariables?.ENABLE_SEARCH_AS_ICON || expandedSearchBar}"
                type="text" #searchValueWeb i18n-placeholder 
                placeholder="{{ 'input_text.InputSearch2' | translate }}" 
                search autocomplete="off" 
                (keyup)="completeResultsLoaded = false; completResults = null;
                        autoCompleteSearch($event, searchValueWeb.value)" 
                [(ngModel)]="searchInput" [ngModelOptions]="{ standalone: true }" />
              <button *ngIf="searchInput?.length != 0 || environmentVariables?.ENABLE_SEARCH_AS_ICON || expandedSearchBar"
                type="button" mat-fab class="close-btn remove-search-value"
                (click)="removeSearchQuery();expandSearchBar()">
                <img loading="lazy" *ngIf="loadingAutoComplete" src="./../../../../assets/images/Spinner-loading.svg"
                  alt="loading image" />
                <mat-icon *ngIf="!loadingAutoComplete" class="material-icons" style="position: relative; left: -8px">
                  close
                </mat-icon>
              </button>
            </form>
            <div *ngIf="isMenuOpen" class="res_search_div" id="autocomp" 
              [ngClass]="{ 'border-search': completeResultsLoaded && searchInput?.length != 0 }">
              <div class="row">
                <div class="col-md-6" *ngFor="let product of completResults">
                  <div class="div_data" (click)="showProductPage(product)">
                    <div class="div1" *ngIf="product?.image">
                      <img loading="lazy" data-src="{{ product?.image }}" alt="product image"
                        onError="this.src='./assets/images/placeholder200.jpg';" class="lazyload" />
                    </div>
                    <div class="div2">
                      <h6> 
                        {{ lang == "ar" ? product.name_ar : product.name_en }}
                      </h6>
                      <div class="d-flex align-items-start">
                        <div class="my-2" class="d-flex align-items-start">
                          <del style="
                                                            font-size: 13px !important;
                                                        " *ngIf="
                                                            product?.discount_price &&
                                                            environmentVariables?.GUEST_CAN_VIEW_PRICES
                                                        " [ngClass]="{
                                                            'config-price-after-discount':
                                                                product?.discount_price &&
                                                                environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                                                            'config-price-color':
                                                                environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                                                            'defult-price-color-after-discount':
                                                                !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                                                                product?.discount_price,
                                                            'price-ar':
                                                                lang == 'ar'
                                                        }">
                            {{ product?.price }}
                            {{
                            lang == "en"
                            ? environmentVariables?.CURRENCY_CODE_EN
                            : environmentVariables?.CURRENCY_CODE_AR
                            }}
                          </del>
                          <div
                            class="payment-with-discount-container d-flex defult-price-color payment-with-discount-container d-flex"
                            [ngClass]="{
                                                            'price-ar':
                                                                lang == 'ar',
                                                            'config-price-before-discount':
                                                                product?.discount_price &&
                                                                environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
                                                            'config-price-color':
                                                                environmentVariables?.PRODUCT_PRICE_TEXT_COLOR &&
                                                                !product?.discount_price
                                                        }">
                            <ng-container *ngIf="
                                                                product?.price &&
                                                                environmentVariables?.GUEST_CAN_VIEW_PRICES
                                                            ">
                              <span>
                                {{
                                product?.discount_price !==
                                null
                                ? product?.discount_price
                                : product?.price
                                }}
                                {{
                                lang == "en"
                                ? environmentVariables?.CURRENCY_CODE_EN
                                : environmentVariables?.CURRENCY_CODE_AR
                                }}
                              </span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p *ngIf="
                                    completResults?.length == 0 &&
                                    searchInput?.length != 0 &&
                                    completeResultsLoaded
                                " class="empty_p">
                {{ "auto_complete.no_results" | translate }}
              </p>
              <p (click)="moreProductsClick()" *ngIf="
                                    searchInput?.length != 0 &&
                                    !completeResultsLoaded
                                " class="auto-complete-text">
                {{
                "auto_complete.view_all_search_about"
                | translate
                }}
                <b> "{{ searchInput }}"</b>
              </p>
              <div class="btn_div" *ngIf="completResults?.length > 9">
                <button mat-raised-button (click)="moreProductsClick()">
                  {{ "home_Page.viewAll" | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop Menu Item -->
        <div class="d-md-flex d-none"
          [ngClass]="{'ml-3 mr-auto': environmentVariables?.ENABLE_SEARCH_AS_ICON}" 
          *ngIf="!expandedSearchBar">
          <div class="our-stores-container d-flex align-items-center mr-2 hidden-media-768"
            [style.background]="environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR"
            [ngClass]="{'px-0': !environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR}"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON === true" (click)="
                          navigateToLink(
                              environmentVariables?.MENU_BUTTON_LINK
                                  ? environmentVariables?.MENU_BUTTON_LINK
                                  : ''
                          )
                      ">
            <img loading="lazy" class="mx-1" [src]="environmentVariables?.MENU_BUTTON_IMAGE" alt="menu image" 
              *ngIf="environmentVariables?.MENU_BUTTON_IMAGE"
            />
  
            <span class="mx-1">
              {{
              lang == "en"
              ? environmentVariables?.MENU_BUTTON_TEXT
              : environmentVariables?.MENU_BUTTON_TEXT_AR
              }}
            </span>
          </div>
  
          <!-- Menu Item 2 -->
          <div class="our-stores-container d-flex align-items-center mr-2"
            [style.background]="environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR_2"
            [ngClass]="{'px-0': !environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR_2}"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_2 === true" 
            (click)="
              navigateToLink(
                environmentVariables?.MENU_BUTTON_LINK_2
                  ? environmentVariables?.MENU_BUTTON_LINK_2
                  : ''
              )">
            <img loading="lazy" class="mx-1" [src]="environmentVariables?.MENU_BUTTON_IMAGE_2" alt="menu image" 
              *ngIf="environmentVariables?.MENU_BUTTON_IMAGE_2"
            />
  
            <span class="mx-1">
              {{
                lang == "en"
                ? environmentVariables?.MENU_BUTTON_TEXT_2
                : environmentVariables?.MENU_BUTTON_TEXT_AR_2
              }}
            </span>
          </div>
  
          <!-- Menu Item 3 -->
          <div class="our-stores-container d-flex align-items-center mr-2"
            [style.background]="environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR_3"
            [ngClass]="{'px-0': !environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR_3}"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_3 === true" 
            (click)="
              navigateToLink(
                environmentVariables?.MENU_BUTTON_LINK_3
                  ? environmentVariables?.MENU_BUTTON_LINK_3
                  : ''
              )">
            <img loading="lazy" class="mx-1" [src]="environmentVariables?.MENU_BUTTON_IMAGE_3" alt="menu image" 
              *ngIf="environmentVariables?.MENU_BUTTON_IMAGE_3"
            />
  
            <span class="mx-1">
              {{
                lang == "en"
                ? environmentVariables?.MENU_BUTTON_TEXT_3
                : environmentVariables?.MENU_BUTTON_TEXT_AR_3
              }}
            </span>
          </div>
  
          <!-- Menu Item 4 -->
          <div class="our-stores-container d-flex align-items-center mr-2"
            [style.background]="environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR_4"
            [ngClass]="{'px-0': !environmentVariables?.MENU_BUTTON_BACKGROUND_COLOR_4}"
            *ngIf="environmentVariables?.ENABLE_MENU_BUTTON_4 === true" 
            (click)="
              navigateToLink(
                environmentVariables?.MENU_BUTTON_LINK_4
                  ? environmentVariables?.MENU_BUTTON_LINK_4
                  : ''
              )">
            <img loading="lazy" class="mx-1" [src]="environmentVariables?.MENU_BUTTON_IMAGE_4" alt="menu image" 
              *ngIf="environmentVariables?.MENU_BUTTON_IMAGE_4"
            />
  
            <span class="mx-1">
              {{
                lang == "en"
                ? environmentVariables?.MENU_BUTTON_TEXT_4
                : environmentVariables?.MENU_BUTTON_TEXT_AR_4
              }}
            </span>
          </div>
        </div>

        <div class="centerOnMobileScreen menu-items">
          <div *ngIf="
                            ((user?.area?.name && user?.area?.available) ||
                                user?.branch) &&
                            environmentVariables?.ENABLE_MULTI_INVENTORY
                        " (click)="
                            user?.branch ? openBranchPopup() : openAreaPopup()
                        " class="Invintory-area" [ngStyle]="{ color: headerTextColor }">
            <ng-container *ngIf="
                                environmentVariables?.PICKUP_DELIVERY_SOURCE !=
                                    'store' ||
                                (environmentVariables?.PICKUP_DELIVERY_SOURCE ==
                                    'both' &&
                                    user?.area &&
                                    !user?.branch)
                            ">
              <span class="area-name ml-2">
                {{
                lang == "en"
                ? (user?.area?.name | slice : 0 : 7)
                : (user?.area?.name_ar | slice : 0 : 7)
                }}
              </span>
            </ng-container>

            <ng-container *ngIf="
                                environmentVariables?.PICKUP_DELIVERY_SOURCE ==
                                    'store' ||
                                (environmentVariables?.PICKUP_DELIVERY_SOURCE ==
                                    'both' &&
                                    !user?.area &&
                                    user?.branch)
                            ">
              {{
              lang == "en"
              ? user?.branch?.shop_name
              : user?.branch?.shop_name_ar
              }}
            </ng-container>

            <span class="inv-header-icon">
              <app-source-icons *ngIf="
                                    environmentVariables?.PICKUP_DELIVERY_SOURCE !=
                                    'store'
                                " [source_type]="'area'"></app-source-icons>
            </span>
            <span class="inv-header-icon">
              <app-source-icons *ngIf="
                                    environmentVariables?.PICKUP_DELIVERY_SOURCE ==
                                    'store'
                                " [source_type]="'store'"></app-source-icons>
            </span>
          </div>

          <div class="d-flex flex-wrap align-items-center">
            <!-- if User Login -->
            <div *ngIf="environmentVariables?.ENABLE_SEARCH_AS_ICON && !expandedSearchBar">
              <button class="header-icon material-symbols-outlined" mat-mini-fab matBadgePosition="after" 
                (click)="expandSearchBar()"
                [ngClass]="{
                  'white-outline':
                    environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
                  'icons-background':
                    environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                    environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
                  'defult-background-icons':
                    !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
                }">
                <mat-icon style="margin-top: -1px"
                  class="material-icons notranslate defulat-icons-color" 
                  [ngClass]="{
                    'material-symbols-outlined':
                      (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
                    'icons-fill-color':
                      environmentVariables?.HEADER_ICONS_FILL_COLOR
                  }">
                  search
                </mat-icon>
              </button>
            </div>

            <embryo-HeaderCart (removeProductData)="openConfirmationPopup($event)" [productList]="productList"
              [lang]="lang">
            </embryo-HeaderCart>

            <embryo-WishList [ngClass]="{
                                'hide-menu-icons':
                                    environmentVariables?.ENABLE_MULTI_INVENTORY
                            }" (addAllWishlistToCart)="
                                addAllWishlistToCart($event)
                            " (addToCart)="addToCart($event)" [lang]="lang">
            </embryo-WishList>

            <app-compare-list-menu [ngClass]="{
                                'hide-menu-icons':
                                    environmentVariables?.ENABLE_MULTI_INVENTORY
                            }" class="hide-menu-icons" *ngIf="!environmentVariables?.DISABLE_COMPARE"
              [lang]="lang"></app-compare-list-menu>

            <app-wallet-list-menu class="hide-menu-icons" *ngIf="environmentVariables?.ENABLE_USER_WALLET"
              [lang]="lang"></app-wallet-list-menu>

            <app-stars-list-menu class="hide-menu-icons" [lang]="lang" *ngIf="
                                environmentVariables?.LOYALTY_PROVIDER ==
                                    'elDokan' ||
                                environmentVariables?.LOYALTY_PROVIDER ==
                                    'sadhan'
                            ">
            </app-stars-list-menu>

            <app-notification-list-menu [lang]="lang">
            </app-notification-list-menu>

            <embryo-HeaderUserProfileDropdown></embryo-HeaderUserProfileDropdown>

            <embryo-LanguageDropDown
              [lang]="lang"
              [environmentVariables]="environmentVariables">
            </embryo-LanguageDropDown>

            <!-- if User just visitor -->
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar-row>
  
  <mat-toolbar-row *ngIf="showTotalPriceMenu" color="basic" class="header-v2-top header-v2-top-total px-0" [ngStyle]="{
            'background-color': environmentVariables?.HEADER_BACKGROUND_COLOR
        }">
    <button *ngIf="!embryoService?.paymentSidenavOpen" class="mobile-only w-100 px-0" mat-raised-button color="accent"
      (click)="toggleRightSidenav()">
      <div class="w-100 h-100 total-price-button">
        <div>
          <span class="more-details w-25">
            {{ productList?.length }}
            {{ lang === "en" ? productList?.length === 1 ? "item" : "items" : productList?.length === 1 ? "منتج" : "منتجات" }}
            <mat-icon class="mx-2">
              {{ environmentVariables?.HEADER_CART_ICON ? environmentVariables?.HEADER_CART_ICON : "shopping_cart" }}
            </mat-icon>
          </span>
        </div>
        <div style="display: flex; align-items: center">
          <span *ngIf="!promoObject?.free_delivery">
            {{ "wallet.Total" | translate }}
            :
            {{ getTotalPrice() | number : "1.2-2" }}
            {{ lang == "en" ? environmentVariables?.CURRENCY_CODE_EN : environmentVariables?.CURRENCY_CODE_AR }}
          </span>
          <mat-icon style="color: #fff" class="mx-2"> menu </mat-icon>
        </div>
      </div>
    </button>
  </mat-toolbar-row>

  <mat-toolbar-row 
    class="header-v2-bottom main-menu-wrap height-235" 
    [ngStyle]="{ 'background-color': environmentVariables?.HEADER_BACKGROUND_COLOR }" 
    [ngClass]="{
      'box-shadow-bottom-none':
          environmentVariables?.ENABLE_MENU_AS_CARDS,
      'border-bottom-2': !environmentVariables?.ENABLE_MENU_AS_CARDS || !showcards,
      'd-none':
          !environmentVariables?.ENABLE_MENU_AS_CARDS &&
          isScreenLessThan500px}">
    <div class="menu-container menu-dynamic-container">
      <ng-container>
        <button class="know-scrol" (click)="slide()" *ngIf="embryoService?.showScrollButton2"
          [ngClass]="{'scrol-wide': environmentVariables?.SLIDER_THEME_TYPE !== 'container'}">
          <i *ngIf="lang == 'en'" class="fa fa-chevron-right"></i>
          <i *ngIf="lang == 'ar'" class="fa fa-chevron-left"></i>
        </button>
      </ng-container>

      <div class="header-v2-bottom-inner">
        <embryo-Menu [CategoriesMenu]="Categories" [lang]="lang"></embryo-Menu>
      </div>

      <ng-container>
        <button class="know-scrol2" (click)="slideFlibed()" *ngIf="embryoService?.showScrollButton2"
          [ngClass]="{'scrol-wide': environmentVariables?.SLIDER_THEME_TYPE !== 'container'}">
          <i *ngIf="lang == 'ar'" class="fa fa-chevron-right"></i>
          <i *ngIf="lang == 'en'" class="fa fa-chevron-left"></i>
        </button>
      </ng-container>
    </div>
  </mat-toolbar-row>
</mat-toolbar>